function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.05567,2.00407,5.49659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.183,13.482C1.183,13.482 4.433,14.784 5.783,14.784C5.783,14.784 8.357,15.474 10.056,13.254C10.056,13.254 10.473,12.646 9.907,12.351C9.907,12.351 4.369,10.627 4.76,9.669C4.76,9.669 4.736,9.128 5.448,9.251C5.448,9.251 6.249,8.551 5.858,8.306C5.858,8.306 5.244,7.765 5.735,7.716C5.735,7.716 6.985,7.796 7.453,7.919C7.453,7.919 7.772,7.804 7.477,7.583C7.182,7.361 6.693,6.864 6.791,6.766C6.791,6.766 6.961,6.348 7.748,6.692C7.748,6.692 7.993,6.643 7.772,6.397C7.772,6.397 7.11,6.004 7.429,5.684C7.429,5.684 8.424,5.035 10.707,7.811C10.707,7.811 11.125,8.376 11.173,7.835C11.173,7.835 12.829,0.714 15.504,0.247C15.504,0.247 16.363,0.419 16.536,0.149C16.536,0.149 17.28,-0.146 17.525,0.099C17.525,0.099 17.772,0.468 18.064,0.247C18.064,0.247 19.12,-0.171 18.801,0.517C18.801,0.517 17.714,1.557 17.347,1.581C16.977,1.606 17.051,1.95 17.371,1.999C17.371,1.999 21.864,2.394 21.864,5.687C21.864,5.687 22.122,6.469 22.957,5.658C22.957,5.658 24.22,4.853 24.539,4.815C24.539,4.815 24.882,4.594 24.834,5.11C24.834,5.11 23.925,6.684 22.991,7.126C22.991,7.126 22.428,7.838 23.239,7.691C23.239,7.691 24.026,7.528 24.395,7.307C24.395,7.307 25.352,6.84 24.908,7.676C24.908,7.676 22.893,8.985 22.452,8.985C22.452,8.985 22.156,9.058 22.156,9.329C22.156,9.329 21.888,17.989 10.644,17.989C10.644,17.989 5.015,18.445 1.332,14.121C1.332,14.121 0.62,13.358 1.183,13.482Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d24a4608600f831e392a204429d2a2f1.svg";
export { ForwardRef as ReactComponent };